import { lazy, Suspense, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import Landing from './Landing';

// Lazy load auth context to avoid loading Supabase on landing page for unauthenticated users
const AuthChecker = lazy(() => import('@/components/auth/AuthChecker'));

const Index = () => {
  const [shouldCheckAuth, setShouldCheckAuth] = useState(false);

  useEffect(() => {
    // Check if there's a potential session (cookie/localStorage indicator)
    // This avoids loading Supabase for first-time visitors
    const hasSession = localStorage.getItem('sb-rdijftipmfmtydcgmikl-auth-token');
    if (hasSession) {
      setShouldCheckAuth(true);
    }
  }, []);

  // For users without session indicators, show landing immediately
  if (!shouldCheckAuth) {
    return <Landing />;
  }

  // For users with potential session, check auth state
  return (
    <Suspense fallback={
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    }>
      <AuthChecker />
    </Suspense>
  );
};

export default Index;
